import React, { useEffect, useRef, useState } from 'react'
import { Button, Modal } from 'react-bootstrap'
import Icon from '../../components/icons'
interface props {
  show: boolean,
  onClose: (status: boolean) => void
}

export default function Modal2({ show, onClose }: props) {
  const handleClose = () => {
    onClose(false)
  }

  return (
    <Modal show={show} onHide={handleClose} className="signupModal">
      {/* <Modal.Header closeButton>
        <Modal.Title>Please verify your Email and Phone no</Modal.Title>
      </Modal.Header> */}
      <div className="modal-content">
        <div className="modal-header border-0 pb-0">
          <div className="d-flex align-items-center justify-content-end w-100 mb-0 pb-0">

            <button type="button" data-dismiss="modal" aria-label="Close" className="close">
              <Icon name='close' onClick={handleClose} />
            </button>
          </div>
        </div>
        <div className="modal-body pt-0">
        <h2 className="mb-3">Please Verify Your Mobile</h2>

          <div className="form-group m-0 verify_inputctrl">
            <input type="text" className="form-control verify_input" placeholder="info@hotmail.com" />
            <span className="verified_txt"><Icon name='verified' /> Verified</span>
          </div>
          <div className="form-group  mt-3 verify_inputctrl">
            <input type="text" className="form-control verify_input" placeholder="9854215487" />
            <a className="editBtn"><Icon name='edit' /></a>
            <span className="verify_btn">Verify</span>
          </div>
          <div className="d-flex justify-content-end">
            <a href="#" className="skip_txt" onClick={handleClose}>Skip</a>
          </div>

        </div>
      </div>
    </Modal>
  )
}